import Element from './Element';
import OverlayComponent from '../../Component/UI/Overlay';
import Interactable from '../../Component/Interactable';
import AnimationComponent from '../../Component/Animation';

export default class Overlay extends Element {
    create(params: any): void {
        super.create({
            type: 'group',
            name: 'overlay',
            layout: {
                anchors: [0, 0, 1, 1],
                pivot: [0.5, 0.5],
            },
            components: [
                {
                    type: 'transparency',
                    data: { alpha: params.alpha ? params.alpha : 0 },
                },
                {
                    type: 'rect',
                    data: {
                        color: params.color ? params.color : [0, 0, 0, 204],
                    },
                },
            ],
            ...params,
        });
    }

    protected onCreate(params: any): void {
        super.onCreate(params);

        this.addComponent(OverlayComponent, params);

        this.addComponent(AnimationComponent, params);

        this.addComponent(Interactable, {
            enabled: false,
            buttonMode: false,
        });
    }
}
